
























































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import HospitalListItem from './hospital-list-item.vue';
import { Hospital } from '@/store/types';
import { useRouter, RouterAliases } from '@/router';
import Fuse from 'fuse.js';

@Component({
  components: {
    HospitalListItem,
  },
})
export default class extends Vue {
  @Prop()
  public hospitals!: Hospital[];

  private search = '';

  private get isSearchVisible(): boolean {
    return this.search.length > 0;
  }

  get fuse(): Fuse<Hospital, Fuse.IFuseOptions<Hospital>> {
    return new Fuse(this.hospitals, {
      caseSensitive: false,
      threshold: 0.6,
      shouldSort: true,
      keys: ['name'],
    });
  }

  get filteredHospitals(): Hospital[] {
    if (this.search === '') {
      return this.hospitals;
    }
    // @ts-ignore
    return (
      this.fuse
        .search(this.search)
        // @ts-ignore
        .map(r => r.item)
        .splice(0, 10)
    );
  }

  report(hospitalId: string) {
    // TODO: to support  reuse  emit an event instead
    const router = useRouter();
    router.push({
      name: RouterAliases.HOSPITAL_DETAILS,
      params: { hospitalId },
    });
  }

  private onInput(evt: Event) {
    this.search = (evt.target && (evt.target as HTMLInputElement).value) || '';
  }

  @Emit('searchBoxFocus')
  private onFocusSearchBox() {
    return this.search;
  }
  @Emit('searchBoxBlur')
  private onBlurSearchBox() {
    return this.search;
  }
}
